<template>
  <div>
    <b-container>
      <section v-for="(offerType, index) in offerTypes" :key="index">
        <template v-if="offerType.type === type">
          <h1 class="text-left mt-2 mb-3">{{ offerType.title }}</h1>
          <b-row v-if="type === 'CREDIT'">
            <b-col md="3"
              ><div
                class="offer-button-container"
                v-bind:class="{ activeOfferButton: subType === 'all' }"
                @click="subTypeClicked('all')"
              >
                Összes
              </div></b-col
            >
            <b-col md="3"
              ><div
                class="offer-button-container"
                v-bind:class="{ activeOfferButton: subType === 'exim' }"
                @click="subTypeClicked('exim')"
              >
                <span class="sub-type-svg-container"><exim-svg /></span>EXIM támogatott hitelek
              </div></b-col
            >
            <b-col md="3"
              ><div
                class="offer-button-container"
                v-bind:class="{ activeOfferButton: subType === 'kavosz' }"
                @click="subTypeClicked('kavosz')"
              >
                <span class="sub-type-svg-container"><kavosz-svg /></span>Széchenyi Kártya hitelek
              </div></b-col
            >
            <b-col md="3"
              ><div
                class="offer-button-container"
                v-bind:class="{ activeOfferButton: subType === 'mfb' }"
                @click="subTypeClicked('mfb')"
              >
                <span class="sub-type-svg-container"><mfb-svg /></span>MFB támogatott hitelek
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left offer-width" cols="1">
            <b-col>
              <div class="m-1 mt-3" v-for="(offer, index) in filteredCompetitions(offerType.storeName)" :key="index">
                <div class="m-1 offerbox-holder rounded">
                  <b-row>
                    <b-col cols="10" class="offer-name" v-b-toggle="'collapse-' + index">
                      <b-row>
                        <b-col cols="2" lg="1" xl="1">
                          <span class="when-opened">
                            <ChevronRightIcon :size="48" />
                          </span>
                          <span class="when-closed">
                            <ChevronDownIcon :size="48" />
                          </span>
                        </b-col>
                        <b-col cols="9" class="text-left">
                          <h3 class="text-green mb-0">{{ offer.code + ' ' + offer.name }}</h3>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="2" align="right">
                      <BookmarkSvg
                        v-if="
                          selectedUserSoleProprietorship.favoriteCompetitionIds.some(compId => compId === offer._id)
                        "
                        v-on:click.native="removeFromFavorites(offer._id)"
                        style="cursor: pointer"
                      />

                      <BookmarkOutlineSvg
                        v-if="
                          !selectedUserSoleProprietorship.favoriteCompetitionIds.some(compId => compId === offer._id)
                        "
                        v-on:click.native="setToFavorites(offer._id)"
                        style="cursor: pointer"
                      />
                    </b-col>
                  </b-row>

                  <b-collapse v-bind:id="'collapse-' + index">
                    <div class="offer-description mt-3">
                      <b-row>
                        <b-col cols="8" class="col-lg-10" offset="2" offset-lg="1" offset-xl="1">
                          <competition-small-details :competition="offer" />
                          <!-- {{ offer.description }}
                          <template v-if="type === 'CREDIT'">
                            <br />
                            <br />
                            <p><b>Futamidő:</b> {{ offer.creditLength }}</p>
                            <p><b>Hitelösszeg:</b> {{ offer.creditAmount }}</p>
                            <p><b>Kamat:</b> {{ offer.creditInterest }}</p>
                          </template>
                          <br /> -->
                          <!-- <b-button @click="handleOfferLink(offer.link)" class="mt-3">Érdekel</b-button> -->
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </b-col>
          </b-row>
        </template>
      </section>
    </b-container>
  </div>
</template>

<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import { mapGetters } from 'vuex'
import queryString from 'query-string'
import _ from 'lodash'
import BookmarkOutlineSvg from '../components/svg/BookmarkOutline'
import BookmarkSvg from '../components/svg/Bookmark'
import EximSvg from '../components/svg/SubType/Exim'
import KavoszSvg from '../components/svg/SubType/Kavosz'
import MfbSvg from '../components/svg/SubType/Mfb'
import CompetitionSmallDetails from './Competitions/components/CompetitionSmallDetails.vue'

export default {
  name: 'SoleProprietorshipOfferList',
  components: {
    ChevronDownIcon,
    ChevronRightIcon,
    BookmarkOutlineSvg,
    BookmarkSvg,
    EximSvg,
    KavoszSvg,
    MfbSvg,
    CompetitionSmallDetails
  },
  computed: {
    ...mapGetters([
      'competitionApplications',
      'competitionGuarantees',
      'competitionCapitalProducts',
      'selectedUserSoleProprietorship',
      'competitionCredits'
    ])
  },
  data() {
    return {
      type: '',
      subType: 'all',
      offerTypes: [
        {
          type: 'CREDIT',
          storeName: 'competitionCredits',
          title: 'Államilag támogatott, kedvező kamatozású hitelek'
        },
        {
          type: 'APPLICATION',
          storeName: 'competitionApplications',
          title: 'Támogatások'
        },
        {
          type: 'CAPITAL_PRODUCT',
          storeName: 'competitionCapitalProducts',
          title: 'Tőkeprogram'
        },
        {
          type: 'GUARANTEE',
          storeName: 'competitionGuarantees',
          title: 'Hitelgarancia'
        }
      ]
    }
  },
  async created() {
    const params = queryString.parse(location.search)
    const { userSoleProprietorshipId, type } = params

    this.type = type

    if (!userSoleProprietorshipId) {
      //TODO: ADD A MESSAGE THAT THIS PAGE NEEDS AN ACTUAL USERSoleProprietorship ATTACHED TO THE QUERYD SoleProprietorship
      this.$router.push('/home')
    }

    if (!type) {
      //TODO: ADD A MESSAGE THAT THIS PAGE NEEDS AN ACTUAL type ATTACHED TO THE QUERYD SoleProprietorship
      this.$router.push('/home')
    }

    await this.$store.dispatch('getUserSoleProprietorship', { userSoleProprietorshipId })

    if (!this.selectedUserSoleProprietorship) {
      //TODO: ADD A MESSAGE THAT THIS PAGE NEEDS AN ACTUAL USERSoleProprietorship ATTACHED TO THE QUERYD SoleProprietorship
      this.$router.push('/home')
    }

    await this.$store.dispatch('getCompetitionsSoleProprietorship', {
      soleProprietorshipId: this.selectedUserSoleProprietorship.soleProprietorshipId
    })

    this.$gtag.event('sole_proprietorship_offers_private', {
      event_category: 'user_interaction',
      soleProprietorshipId: this.selectedUserSoleProprietorship.soleProprietorshipId
    })
  },
  methods: {
    subTypeClicked: function(value) {
      this.subType = value
    },
    filteredCompetitions: function(offerName) {
      switch (this.subType) {
        case 'all':
          return this[offerName]
        case 'exim':
          return this[offerName].filter(o => o.subType === 'EXIM')
        case 'kavosz':
          return this[offerName].filter(o => o.subType === 'KAVOSZ')
        case 'mfb':
          return this[offerName].filter(o => o.subType === 'MFB')
      }
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    },
    async setToFavorites(competitionId) {
      const extendedFavoriteCompetitionIds = _.uniq([
        competitionId,
        ...this.selectedUserSoleProprietorship.favoriteCompetitionIds
      ])

      await this.$store.dispatch('patchUserSoleProprietorship', {
        userSoleProprietorshipId: this.selectedUserSoleProprietorship.id,
        favoriteCompetitionIds: extendedFavoriteCompetitionIds
      })

      this.$store.dispatch('getUserSoleProprietorship', {
        userSoleProprietorshipId: this.selectedUserSoleProprietorship.id
      })
    },
    async removeFromFavorites(competitionId) {
      const filteredFavoriteCompetitionIds = this.selectedUserSoleProprietorship.favoriteCompetitionIds.filter(
        favoriteCompetitionId => favoriteCompetitionId !== competitionId
      )
      await this.$store.dispatch('patchUserSoleProprietorship', {
        userSoleProprietorshipId: this.selectedUserSoleProprietorship.id,
        favoriteCompetitionIds: filteredFavoriteCompetitionIds
      })

      this.$store.dispatch('getUserSoleProprietorship', {
        userSoleProprietorshipId: this.selectedUserSoleProprietorship.id
      })
    },
    handleOfferLink(link) {
      const win = window.open(link, '_blank')
      win.focus()
    }
  }
}
</script>

<style scoped>
.offer-width {
  max-width: 800px;
}

.offerbox-holder {
  padding: 20px;
  padding-top: 30px;
  border: 1px solid var(--color-gray-02);
  box-sizing: border-box;
  box-shadow: 0px 2px 12px rgba(45, 52, 54, 0.05);
  min-height: 80px;
}

.offer-name {
  color: var(--color-green);
  font-weight: bold;
}

.offerbox-holder .btn {
  width: 200px;
  height: 48px;
  padding: 11px;
}

.offer-name:focus {
  outline: none;
}

.offerbox-holder .btn {
  width: 200px;
  height: 48px;
  padding: 11px;
}

.collapsed > div > div > .when-opened,
:not(.collapsed) > div > div > .when-closed {
  display: none;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: -10px;
  transition: opacity 1s ease-out;
}

.pre-link {
  width: fit-content;
}

.heart-container {
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 10px;
}

.competition-container {
  position: relative;
}

.offer-button-container {
  background: #ffffff;
  padding: 8px 16px 8px 16px;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  border-radius: 4px;
  transition: background 0.1s ease-in-out;
  font-size: 16px;
}

.offer-button-container:hover {
  background: #f2f8fa;
  cursor: pointer;
}

.sub-type-svg-container {
  margin-right: 17px;
}

.activeOfferButton {
  background: #f2f8fa;
}
</style>
